import { render } from "./form5.vue?vue&type=template&id=7f3579f1&scoped=true&ts=true"
import script from "./form5.vue?vue&type=script&lang=ts"
export * from "./form5.vue?vue&type=script&lang=ts"

import "./form5.vue?vue&type=style&index=0&id=7f3579f1&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3579f1"]])

export default __exports__